import { useQuery } from '@tanstack/react-query';

import { makeAPIRequestReactQuery } from '@/react-query/api';
import { endpoints } from '@/react-query/endpoints';

interface PreQualifyReportResponse {
  compatible: boolean;
}

export const usePreQualifyReport = (dealId: string | null) => {
  return useQuery(
    [endpoints.connector.compatibility, dealId],
    () =>
      makeAPIRequestReactQuery<PreQualifyReportResponse>(
        endpoints.connector.compatibility,
        { code: dealId },
        'GET',
        undefined,
        true,
      ),
    { enabled: !!dealId },
  );
};
